// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__32MhM","addWidgetButton":"Header_addWidgetButton__OruGD","dashboardTabs":"Header_dashboardTabs__3Mh_7","active":"Header_active__3ZLlE"};